import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'For Public Entities', path: '/public-entities' },
    { name: 'For Small Business', path: '/small-business' },
    { name: 'About', path: '/about' },
    { name: 'How We Work', path: '/how-we-work' },
    { name: 'Contact', path: '/contact' },
    { name: 'Accessibility Report', path: '/accessibility-conformance-report' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-[#1e3a5f] shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0">
            <img
              src="/Lone_Star_Republic_Consulting-2.png"
              alt="Lone Star Republic Consulting"
              className="h-14 w-auto"
            />
          </Link>

          {/* Desktop Navigation — right-aligned */}
          <nav className="hidden lg:flex items-center gap-1" aria-label="Main navigation">
            {navigation.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-3 py-2 min-h-[44px] flex items-center text-sm font-medium rounded transition-colors ${
                  isActive(item.path)
                    ? 'text-white bg-[#c84630]'
                    : 'text-gray-200 hover:text-white hover:bg-[#2a4a6f]'
                }`}
                aria-current={isActive(item.path) ? 'page' : undefined}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* Mobile: Hamburger */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2 rounded-md text-gray-200 hover:bg-[#2a4a6f] min-w-[44px] min-h-[44px] flex items-center justify-center"
            aria-expanded={mobileMenuOpen}
            aria-controls="mobile-navigation-menu"
            aria-label={mobileMenuOpen ? "Close navigation menu" : "Open navigation menu"}
          >
            {mobileMenuOpen ? <X size={24} aria-hidden="true" /> : <Menu size={24} aria-hidden="true" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation Dropdown */}
      {mobileMenuOpen && (
        <div id="mobile-navigation-menu" className="lg:hidden border-t border-[#2a4a6f]">
          <nav aria-label="Mobile navigation">
            {navigation.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setMobileMenuOpen(false)}
                className={`block px-4 py-3 text-base font-medium ${
                  isActive(item.path)
                    ? 'text-white bg-[#c84630]'
                    : 'text-gray-200 hover:bg-[#2a4a6f]'
                }`}
                aria-current={isActive(item.path) ? 'page' : undefined}
              >
                {item.name}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
